import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { NotificationBanner } from '../../../models/notification-class.enum';
import { CVA_CONSTANTS } from '../../../util/constants';
import { CustomLoginService } from '@privatelib/ngx18-authz-dev';
import { LoginService } from '../../../services/login/login.service';
import { Subscription } from 'rxjs';
import { FuseAlertComponent } from '@fuse/components/alert';
import { fuseAnimations } from '@fuse/animations';
import { ActivatedRoute } from '@angular/router';
import { CVA_AUTH_MODULES } from 'app/models/auth.modules.enum';
import { FuseAlertType } from '@fuse/components/alert/alert.types';
import { PaymentService } from 'app/services/payment/payment.service';
@Component({
  selector: 'cva-standalone-subscription-validator',
  templateUrl: './subscription-validator.component.html',
  styleUrl: './subscription-validator.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FuseAlertComponent],
  animations: fuseAnimations
})
export class SubscriptionValidatorComponent implements OnDestroy {
  public loginStatusSubscription!: Subscription;
  notification!: NotificationBanner | undefined;

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private authorize: CustomLoginService,
    public loginService: LoginService,
    private paymentService: PaymentService,
    private route: ActivatedRoute
  ) { }

  /* ngOnInit(): void {
    // Do not show the license end notification for AeroCloud for now
    this.loginStatusSubscription = this.loginService.loggedIn$.subscribe((val: boolean) => {
      if (val) {
        this.checkUserValidity();
      } else {
        this.notification = null;
      }
    });
  } */

  async checkIfCurrentUserIsAdmin() {
    return await this.authorize.IsAuthorized(
      CVA_AUTH_MODULES.CVA_LICENSE_MANAGEMENT,
      CVA_CONSTANTS.PERMISSION.READ
    );
  }

  checkUserValidity(): void {
    this.paymentService.validateSubscription().subscribe({
      next: (response) => {
        if (!response) {
          this.notification = null;
          this._changeDetectorRef.markForCheck();
          return;
        }
        this.checkIfCurrentUserIsAdmin().then((isAdmin) => {
          if (isAdmin || (!isAdmin && (response.isCancelled || response.isPaused))) {
            this.notification = {
              type: response.alertType as FuseAlertType,
              message: response.message
            }
          } else {
            this.notification = null;
          }
          this._changeDetectorRef.markForCheck();
        }).catch((error) => {
          this.notification = null;
          throw error;
        })
      },
      error: (err) => {
        this.notification = null;
        console.error('Failed to fetch subscription status', err);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.loginStatusSubscription) {
      this.loginStatusSubscription.unsubscribe();
    }
  }
}
